import React, { useState, useEffect } from "react";
import { Route,Routes } from 'react-router-dom';
import { Helmet } from "react-helmet";
import { Footer } from "./Components/Footer";
import Hero from "./Components/Hero";
import Home from "./Pages/Home"
import Gallery from "./Pages/Gallery"
import Contact from "./Pages/Contact"
import MapContainer from "./Pages/Map"
import Nav from "./Components/Nav";
import WordPress from "./Util/wordpress";
import ReactMapboxGl from 'react-mapbox-gl';
import mapboxgl from 'mapbox-gl';
import "./App.scss";
// eslint-disable-next-line import/no-webpack-loader-syntax
mapboxgl.workerClass = require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default;
// disable map zoom when using scroll

const wp = new WordPress();
const Map = ReactMapboxGl({
    accessToken: "pk.eyJ1Ijoic3BlbnNlcmxlaWdodG9uMSIsImEiOiJjbDB3Nm9hbjYxZHNvM2NwbmsydnE3NnpnIn0.r7KsR8MDpuPnql6SP5YSAw",
    scrollZoom: false
});

function App() {
    const [defaultContent, setDefaultContent] = useState([]);
    const [gallery, setGallery] = useState({});
    const [mapPins, setMapPins] = useState({});

    useEffect(() => {
        wp.fetchHome()
            .then(page => {
                console.log({page})
                setGallery(page.gallery)
                setDefaultContent(page.defaultContent)
                setMapPins(page.mapPins)
            })
    }, []);

    return (
        <div className="App">
            <Helmet>
                <title>Jeremy Burns | A very good Denver boy.</title>
            </Helmet>
            <Hero />
            <Nav />
            <div className="page-content">
                <div className="container">
                    <Routes>
                        <Route path='/' exact element={<Home defaultContent={defaultContent} />} />
                        <Route path='/gallery' exact element={<Gallery gallery={gallery} />} />
                        <Route path='/contact' exact element={<Contact />} />
                    </Routes>
                </div>
            </div>
                <Routes>
                    <Route path='/map' exact element={<MapContainer Map={Map} mapPins={mapPins} />} />
                </Routes>
            <Footer />
        </div>
    );
}

export default App;
